import React, { createContext, type ReactNode, useContext } from 'react';

import { usePreferences, type UsePreferencesReturn } from '../../hooks/use-preferences';

type PreferencesContextType = (UsePreferencesReturn & { workspaceId: string }) | undefined;

const PreferencesContext = createContext<PreferencesContextType>(undefined);

export const PreferencesProvider = ({
	children,
	featureGateKey,
	workspaceId,
}: {
	children: ReactNode;
	featureGateKey: string;
	workspaceId: string;
}): React.JSX.Element => {
	const preferences = usePreferences(featureGateKey, workspaceId);

	const value = {
		...preferences,
		workspaceId,
	};

	return <PreferencesContext.Provider value={value}>{children}</PreferencesContext.Provider>;
};

export const usePreferencesContext = () => {
	const context = useContext(PreferencesContext);
	if (context === undefined) {
		throw new Error('usePreferencesContext must be used within a PreferencesProvider');
	}
	return context;
};
